function addClassIfThreeOrMoreLines( selector, minLines = 3, className = 'three-line' ) {
  document.querySelectorAll( selector ).forEach( el => {
    const style = window.getComputedStyle( el );
    const lineHeight = parseFloat( style.lineHeight );
    const lines = Math.round( el.scrollHeight / lineHeight );

    if ( lines >= minLines ) {
      el.classList.add( className );
    } else {
      el.classList.remove( className ); // Optional cleanup
    }
  } );
}

function initLineDetection() {
  const isWideScreen = window.matchMedia( '(min-width: 1200px)' ).matches;

  if ( isWideScreen ) {
    addClassIfThreeOrMoreLines( '.e-stn--reveal-card h3', 3 );
  } else {
    document.querySelectorAll( '.e-stn--reveal-card h3' ).forEach( el => {
      el.classList.remove( 'three-line' );
    } );
  }
}

window.addEventListener( 'load', initLineDetection );
window.addEventListener( 'resize', initLineDetection );
